import { FC } from "react";
import { Icon, IconProps } from "@chakra-ui/react";

export const Facebook: FC<IconProps> = ({
  fill = "none",
  height = "3rem",
  viewBox = "0 0 54 54",
  width = "3rem",
  ...props
}) => (
  <Icon fill={fill} height={height} viewBox={viewBox} width={width} {...props}>
    <path
      d="M54 27C54 12.0883 41.9117 0 27 0C12.0883 0 0 12.0883 0 27C0 40.4763 9.87346 51.6465 22.7812 53.672V34.8047H15.9258V27H22.7812V21.0516C22.7812 14.2847 26.8123 10.5469 32.9796 10.5469C35.9327 10.5469 39.0234 11.0742 39.0234 11.0742V17.7187H35.6189C32.265 17.7187 31.2188 19.8002 31.2188 21.9375V27H38.707L37.51 34.8047H31.2188V53.672C44.1265 51.6465 54 40.4763 54 27Z"
      fill="currentColor"
    />
    <path d="M37.51 34.8047L38.707 27H31.2188V21.9375C31.2188 19.8023 32.265 17.7188 35.6189 17.7188H39.0234V11.0742C39.0234 11.0742 35.9337 10.5469 32.9796 10.5469C26.8123 10.5469 22.7812 14.2847 22.7812 21.0516V27H15.9258V34.8047H22.7812V53.672C25.5767 54.1093 28.4233 54.1093 31.2188 53.672V34.8047H37.51Z" />
  </Icon>
);
